"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aiRoutes = void 0;
const backendImport_1 = require("@front/backendImport");
const component_1 = require("@front/pages/ai/chat/component");
const component_2 = require("@front/pages/ai/trainer/component");
const component_3 = require("@front/pages/onboarding/wizard/component");
const component_4 = require("@front/pages/onboarding/view/component");
const component_5 = require("@front/pages/onboarding/pick/component");
const component_6 = require("@front/pages/onboarding/list-gate/component");
const component_7 = require("@front/pages/conversation/list/component");
const component_8 = require("@front/pages/conversation/preview/component");
const component_9 = require("@front/pages/bot-test/list/component");
const component_10 = require("@front/pages/bot-test/form/component");
const component_11 = require("@front/pages/bot-test/preview/component");
const component_12 = require("@front/pages/tutorial/list/component");
const component_13 = require("@front/pages/tutorial/form/component");
const component_14 = require("@front/pages/tutorial/preview/component");
exports.aiRoutes = [
    {
        path: '/ai/chat',
        name: 'route.ai.chat'.t(),
        component: component_1.ChatPage,
        icon: 'bubbles',
        inMenu: true,
        acl: `${backendImport_1.ACL.aclResources.ai}.${backendImport_1.ACL.aclActions.read}`
    },
    {
        path: '/onboarding/list',
        name: 'route.onboardings'.t(),
        icon: 'user-following',
        component: component_6.OnboardingListGate,
        inMenu: true,
        acl: `${backendImport_1.ACL.aclResources.onboarding}.${backendImport_1.ACL.aclActions.read}`
    },
    {
        path: '/onboarding/wizard',
        name: 'onboarding.create.title'.t(),
        component: component_3.OnboardingWizardPage,
        forceActive: '/onboarding/list',
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.onboarding}.${backendImport_1.ACL.aclActions.write}`
    },
    {
        path: '/onboarding/wizard/profession/:profession',
        name: 'onboarding.create.title'.t(),
        component: component_3.OnboardingWizardPage,
        forceActive: '/onboarding/list',
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.onboarding}.${backendImport_1.ACL.aclActions.write}`
    },
    {
        path: '/onboarding/wizard/:id',
        name: 'onboarding.edit.title'.t(),
        component: component_3.OnboardingWizardPage,
        forceActive: '/onboarding/list',
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.onboarding}.${backendImport_1.ACL.aclActions.write}`
    },
    {
        path: '/onboarding/:id',
        name: 'onboarding.view.title'.t(),
        component: component_4.OnboardingView,
        forceActive: '/onboarding/list',
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.onboarding}.${backendImport_1.ACL.aclActions.write}`
    },
    {
        path: '/onboarding/pick',
        name: 'onboarding.create.title'.t(),
        component: component_5.OnboardingPick,
        forceActive: '/onboarding/list',
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.onboarding}.${backendImport_1.ACL.aclActions.write}`
    },
    {
        path: '/ai/trainer',
        name: 'trainer.title'.t(),
        component: component_2.TrainerPage,
        icon: 'vector',
        inMenu: true,
        acl: `${backendImport_1.ACL.aclResources.ai}.${backendImport_1.ACL.aclActions.write}`
    },
    {
        path: '/conversation/list',
        name: 'route.conversationList'.t(),
        icon: 'bubble',
        component: component_7.ConversationListPage,
        acl: `${backendImport_1.ACL.aclResources.ai}.${backendImport_1.ACL.aclActions.read}`,
        inMenu: true
    },
    {
        path: '/conversation/preview/:conversationId',
        name: 'route.conversationPreview'.t(),
        component: component_8.ConversationPreviewPage,
        acl: `${backendImport_1.ACL.aclResources.ai}.${backendImport_1.ACL.aclActions.read}`,
        inMenu: false
    },
    {
        path: '/bot-test/list',
        name: 'route.botTest.list'.t(),
        icon: 'settings',
        component: component_9.BotTestListPage,
        acl: `${backendImport_1.ACL.aclResources.botTest}.${backendImport_1.ACL.aclActions.read}`,
        inMenu: true
    },
    {
        path: '/bot-test/preview/:id',
        name: 'botTest.preview.title'.t(),
        component: component_11.BotTestPreview,
        forceActive: '/bot-test/list',
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.botTest}.${backendImport_1.ACL.aclActions.read}`
    },
    {
        path: '/bot-test/create',
        name: 'botTest.create.title'.t(),
        component: component_10.BotTestFormPage,
        forceActive: '/bot-test/list',
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.botTest}.${backendImport_1.ACL.aclActions.write}`
    },
    {
        path: '/bot-test/edit/:id',
        name: 'botTest.edit.title'.t(),
        component: component_10.BotTestFormPage,
        forceActive: '/bot-test/list',
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.botTest}.${backendImport_1.ACL.aclActions.write}`
    },
    {
        path: '/tutorial/list',
        name: 'route.tutorial.list'.t(),
        icon: 'book-open',
        component: component_12.TutorialList,
        acl: `${backendImport_1.ACL.aclResources.ai}.${backendImport_1.ACL.aclActions.read}`,
        inMenu: true
    },
    {
        path: '/tutorial/create',
        name: 'tutorial.create.title'.t(),
        component: component_13.TutorialForm,
        forceActive: '/tutorial/list',
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.ai}.${backendImport_1.ACL.aclActions.write}`
    },
    {
        path: '/tutorial/edit/:id',
        name: 'tutorial.edit.title'.t(),
        component: component_13.TutorialForm,
        forceActive: '/tutorial/list',
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.ai}.${backendImport_1.ACL.aclActions.write}`
    },
    {
        path: '/tutorial/preview/:id',
        name: 'tutorial.preview.title'.t(),
        component: component_14.TutorialPreview,
        forceActive: '/tutorial/list',
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.ai}.${backendImport_1.ACL.aclActions.read}`
    }
];
